import { TypographyMuted } from "@/components/typography/Muted";
import { Button } from "@/components/ui/button";
import Card from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { TabsContent } from "@/components/ui/tabs";
import { ApolloError } from "@apollo/client";
import { Plus } from "lucide-react";
import { PublicApp } from "../types/app.type";
import { AppGalleryView } from "./Gallery/AppGalleryView";
import QuickCreateAppModal from "./QuickCreateApp/QuickCreateAppModal";
import { AppTableView } from "./Table/AppTableView";

interface Props {
  publicApps: PublicApp[];
  loadingPublicApps: boolean;
  publicAppsError?: ApolloError;
}

function NoOrganizationApps({
  publicApps,
  loadingPublicApps,
  publicAppsError
}: Props) {
  return (
    <div className="flex flex-col gap-6">
      <div
        data-testid="noAppsInOrganizationCard"
        className="flex justify-center items-center w-full my-20"
      >
        <Card
          data-testid="selectOrganizationCard"
          className="dark:bg-brand-gray-900"
        >
          <Card.Header className="gap-1">
            <Card.Title className="text-2xl text-center">
              Deploy your first app!
            </Card.Title>
            <Card.Description className="text-center">
              It looks like your organization does not have any apps yet. Get
              started by deploying one with Numerous.
            </Card.Description>
          </Card.Header>
          <Card.Content className="w-fit mx-auto">
            <QuickCreateAppModal>
              <Button
                className="flex items-center gap-1 w-fit"
                data-testid="noAppsInOrganizationCardLink"
                variant="default"
              >
                Start
                <Plus size={16} />
              </Button>
            </QuickCreateAppModal>
          </Card.Content>
        </Card>
      </div>

      {!!publicApps.length && (
        <>
          <Separator className="my-6" />

          <TypographyMuted className="text-center">
            Or get started using public apps
          </TypographyMuted>

          <TabsContent value="gallery">
            <AppGalleryView
              apps={publicApps}
              loading={loadingPublicApps}
              errors={{ publicAppsError }}
            />
          </TabsContent>
          <TabsContent value="table">
            <AppTableView
              apps={publicApps}
              loading={loadingPublicApps}
              errors={{ publicAppsError }}
            />
          </TabsContent>
        </>
      )}
    </div>
  );
}

export default NoOrganizationApps;
